module.exports = __webpack_public_path__ + "static/ADC_Application-0a02fe28f369a128a40c2707ce943f90.pdf";